/**
 * Single source of truth for the backend API base URL.
 *
 * In production builds, REACT_APP_BACKEND_URL must be set at build time
 * (CRA inlines it). If it's missing, we throw rather than silently shipping
 * with a localhost fallback — on iOS, App Transport Security would block
 * every request with no visible cause.
 */
const envUrl = process.env.REACT_APP_BACKEND_URL;

if (process.env.NODE_ENV === 'production' && !envUrl) {
  throw new Error(
    'REACT_APP_BACKEND_URL is not set. Production builds must define it ' +
    '(e.g. https://api.ridesharechecker.com) before running `npm run build`.'
  );
}

export const API_URL = envUrl || 'http://localhost:5001';
